import React from 'react';
import {browserHistory, hashHistory, IndexRedirect, Route, Router} from 'react-router';
import {setLastLocation} from "../redux/actions/global";
import {loginUserIsManager,getThirdPlatformOauthLoginUrl} from "../services/global";
import {admin_url_domin} from "../utils/config";
import {isWeixinBrowser,getIsMobileBrowser,isWeixinWorkBrowser,queryStringParam} from "../utils/index";
import {findUsersEnableToken} from "../services/user";
//react-mobile


export default class MRouter extends React.Component {

    constructor(props) {
        super(props);
        browserHistory.listen((location) => {
            // location is an object like window.location
            //console.log("CRouter", location)
            this.props.store.dispatch(setLastLocation(location))

        })
        this.state ={
            isWeixinBrowser:isWeixinBrowser(),
        }
    }

    requireAuth = (permission, component) => {
        const {store} = this.props;
        const {auth} = store.getState().httpData;
        if (!auth || !auth.data.permissions.includes(permission)) hashHistory.replace('/404');
        return component;
    };


    isLogin = (nextState, replaceState) => {
        const token = localStorage.getItem('token')
        if (!token) {
            replaceState({
                pathname: '/login',
                state: {nextPathname: nextState.location.pathname}
            })
        }
    }

    isLoggedin = (nextState, replaceState) => {
        const token = localStorage.getItem('token')
        console.log("isLoggedin", token)
        if (token) {
            replaceState({
                pathname: '/',
                state: {nextPathname: nextState.location.pathname}
            })
        }
    }

    isManager = (nextState, replaceState) => {
        if (!loginUserIsManager()) {
            replaceState({
                pathname: '/admin/evtm',
                state: {nextPathname: nextState.location.pathname}
            })
        }
    }
    isWeixinLogin = (cb, component,platform='WXMP') => {
        // let ua = navigator.userAgent.toLowerCase();
        let _auth = false;
        if(queryStringParam('hostUserId') && (queryStringParam('hostUserId') != localStorage.getItem('hostUserId'))){
            _auth = true;
            localStorage.clear()
        }

        if(getIsMobileBrowser().isMobile && isWeixinBrowser() && !sessionStorage.getItem('wxlogin')){
            if(browserHistory.getCurrentLocation().pathname.split('/')[2] !='logging'){
                let nowTime=+new Date();
                let lastTime=Number(localStorage.getItem('tokenTimestamp') ? localStorage.getItem('tokenTimestamp') : 0);
                let cycleTime=14*24*60*60*1000;
                if(_auth || !localStorage.getItem('token') || !localStorage.getItem('wxOpenId') || nowTime-lastTime>cycleTime){
                    // if (ua.match(/wxwork/i) == 'wxwork') {
                    //     platform='';
                    // }
                    const redirectUri = `${window.location.origin}/mobile/logging?client_name=${platform}`;
                    sessionStorage.setItem('address',window.location.href);
                    let _data={
                        platform: platform,
                        redirectUri: redirectUri,
                        sourceUrl:encodeURI(sessionStorage.getItem('address'))
                    }
                    getThirdPlatformOauthLoginUrl(_data).then(res => {
                        if (res.code == 200) {
                            localStorage.setItem('hostUserId',queryStringParam('hostUserId'));
                            window.location =res.data;
                        } else {
                            cb(null, component);
                        }
                    }).catch(err => {

                    })
                }else {
                    cb(null, component);
                }
            }

        }else {
            // findUsersEnableToken().then(res=>{
            //     if(!res.data){
            //         localStorage.removeItem('token')
            //     }
            //     cb(null, component);
            // })
            cb(null, component);
        }

    };

    render() {
        return (
            <Router history={browserHistory}>
                <Router path={'/'} getComponent={(location, cb) => {
                    require.ensure([], require => {
                        cb(null, require('../containers/invitation-page/ErrorPage').default)
                    }, 'page')
                }}>
                    <Route path={'mobile'}>
                        {/* <IndexRedirect to="test"/> */}
                        <Route path={'signup/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/Signup').default)
                            }, 'mobile-signup')
                        }}/>
                        <Route path={'voucher'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/Voucher').default)
                            }, 'mobile-voucher')
                        }}/>
                        <Route path={'attendeevoucher'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/AttendeeVoucher').default)
                            }, 'mobile-attendeevoucher')
                        }}/>
                        <Route path={'confirmation'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/confirmation/CustomConfirmation').default)
                            }, 'mobile-voucher')
                        }}/>
                        <Route path={'findvoucher'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/FindVoucher').default)
                            }, 'mobile-findVoucher')
                        }}/>
                        <Route path={'create-evt'} getComponent={(location, cb) => {
                            if(isWeixinWorkBrowser()){
                                window.location.href='http://www.checkinmaster.com/app.html'
                            }else{
                                require.ensure([], require => {
                                    this.isWeixinLogin(cb,require('../containers/invitation-page/SimpleCreateEvt').default)
                                }, 'mobile-createEvt')
                            }
                            
                        }}/>
                        <Route path={'my-event'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/MyEventList').default)
                            }, 'mobile-myEventList')
                        }}/>
                      
                        <Route path={'checkin'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/CheckinNext').default)
                            }, 'mobile-checkinNext')
                        }}/>
                        <Route path={'checkinqrcode'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/CheckinQrcode').default)
                            }, 'mobile-checkinQrcode')
                        }}/>
                        <Route path={'eventqrcode/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/EventQrcode').default)
                            }, 'mobile-eventqrcode')
                        }}/>
                        <Route path={'checkin-dyqrcode'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/CheckinQrcodeIos').default)
                            }, 'mobile-checkinQrcodeIos')
                        }}/>
                        <Route path={'voucherresult'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/VoucherResult').default)
                            }, 'mobile-voucherResult')
                        }}/>
                        <Route path={'checkinselecttickets'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/CheckinSelectTickets').default)
                            }, 'mobile-checkinSelectTickets')
                        }}/>
                        <Route path={'checkinresult'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/CheckinResult').default)
                            }, 'mobile-checkinResult')
                        }}/>
                        <Route path={'checkinattendeeresult'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/CheckinAttendeeResult').default)
                            }, 'mobile-checkinAttendeeResult')
                        }}/>
                        <Route path={'checkinfailure'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/CheckinFailure').default)
                            }, 'mobile-checkinFailure')
                        }}/>
                        <Route path={'chestcard/:contactId'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/ChestCard').default)
                            }, 'mobile-chestCard')
                        }}/>
                        <Route path={'attendeedetails'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/AttendeeDetails').default)
                            }, 'mobile-attendeeDetails')
                        }}/>
                        <Route path={'attendeeinfo'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/AttendeeInfo').default)
                            }, 'mobile-attendeeInfo')
                        }}/>
                        <Route path={'attendeelist/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/AttendeeList').default)
                            }, 'mobile-attendeeList')
                        }}/>
                        <Route path={'wxshareattendeelist/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/WxShareAttendeeList').default)
                            }, 'mobile-WxShareAttendeeList')
                        }}/>
                        <Route path={'wxsharenextattendeelist'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/WxShareNextAttendeeList').default)
                            }, 'mobile-WxShareNextAttendeeList')
                        }}/>
                        <Route path={'commentlist/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/CommentList').default)
                            }, 'mobile-commentlist')
                        }}/>
                        <Route path={'result'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/Result').default)
                            }, 'mobile-result')
                        }}/>
                        <Route path={'invoice-result'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/AttendeeInvoiceResult').default)
                            }, 'mobile-AttendeeInvoiceResult')
                        }}/>
                        <Route path={'logging'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/Logging').default)
                            }, 'mobile-logging')
                        }}/>
                        <Route path={'cancelactivityresult'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/CancelActivityResult').default)
                            }, 'mobile-cancelActivityResult')
                        }}/>
                        <Route path={'mytickets'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/MPEventList').default)
                            }, 'mobile-mPEventList')
                        }}/>
                        <Route path={'personalinfo'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/UserAttendeeInfo').default)
                            }, 'mobile-userAttendeeInfo')
                        }}/>
                        <Route path={'apply-invoice'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null,require('../containers/invitation-page/AttendeeApplyInvoice').default)
                            }, 'mobile-attendeeApplyInvoice')
                        }}/>
                        <Route path={'event/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/template/MEvent').default)
                            }, 'mobile-mEvent')

                        }}/>
                        <Route path={'share/event/:id'} getComponent={(location, cb) => {
                            if(getIsMobileBrowser().isMobile){
                                window.location.href='/mobile/event/'+location.params.id+location.location.search
                            }else {
                                window.location.href=admin_url_domin+'/share/event/'+location.params.id
                            }

                        }}/>
                        <Route path={'invitation-template/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/template/InvitationTemplate').default)
                            }, 'mobile-invitationTemplate')
                        }}/>
                        <Route path={'custom-invitationtemplate/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/template/CustomInvitationTemplate').default)
                            }, 'mobile-customInvitationTemplate')
                        }}/>
                        <Route path={'invitation-custom/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/template/CustomInvitation').default)
                            }, 'mobile-customInvitation')
                        }}/>
                        <Route path={'sudoku/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/template/Sudoku').default)
                            }, 'mobile-sudoku')

                        }}/>
                        <Route path={'sudoku-page'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/template/SudokuPage').default)
                            }, 'sudokuPage')
                        }}/>
                        {/*<Route path={'template'}>*/}
                        {/*<Route path={'event/:id'} component={Event}/>*/}
                        {/*<Route path={'invitation/:id'} component={Invitation}/>*/}
                        {/*</Route>*/}
                        <Route path={'videoguide'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/HelpVideo').default)
                            }, 'helpvideo')
                        }}/>
                        <Route path={'bigwheel/:poolId'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/luckdraw/Bigwheel').default)
                            }, 'bigwheel')
                        }}/>
                        <Route path={'myprize/:poolId'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/luckdraw/Myprize').default)
                            }, 'myprize')
                        }}/>
                        <Route path={'broadcast/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/AppBroadcast').default)
                            }, 'broadcast')
                        }}/>
                        <Route path={'pubevtlist'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/PublicEventList').default)
                            }, 'pubevtlist')
                        }}/>
                        <Route path={'guidepage'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/GuidePage').default)
                            }, 'guidepage')
                        }}/>
                        <Route path={'member-rules'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/MemberRules').default)
                            }, 'memberRules')
                        }}/>
                        <Route path={'questionnairefill/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/QuestionnaireFill').default)
                            }, 'questionnaireFill')
                        }}/>
                        <Route path={'votesfill/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/VotesFill').default)
                            }, 'votesFill')

                        }}/>
                        <Route path={'sendbarrage/:configId'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/SendBarrage').default)
                            }, 'sendBarrage')
                        }}/>
                        <Route path={'redpackets/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/luckymoney/RedPackets').default)
                            }, 'redPackets')
                        }}/>
                        <Route path={'customsudoku'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/custom/CustomSudokuLG').default)
                            }, 'customSudoku')
                        }}/>
                        <Route path={'custom/page'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/custom/Page').default)
                            }, 'page')
                        }}/>
                        <Route path={'custom/xinjin-page'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/custom/XinjingPage').default)
                            }, 'xinjingPage')
                        }}/>
                        <Route path={'custom/fenjiu-page'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/custom/FenjiuPage').default)
                            }, 'fenjiuPage')
                        }}/>
                        <Route path={'custom/tielu-page'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/custom/TieLuPage').default)
                            }, 'tieLuPage')
                        }}/>
                        <Route path={'reward-pay/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/RewardPay').default)
                            }, 'rewardPay')
                        }}/>
                        <Route path={'rewardpay-result/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/RewardPayResult').default)
                            }, 'rewardPayResult')
                        }}/>
                        <Route path={'market-pay/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/MarketPay').default)
                            }, 'marketPay')
                        }}/>
                        <Route path={'marketpay-result/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/MarketPayResult').default)
                            }, 'marketPayResult')
                        }}/>
                        <Route path={'pay/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/Pay').default)
                            }, 'pay')
                        }}/>
                        <Route path={'guess-answer/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/GuessAnswer').default)
                            }, 'guessAnswer')
                        }}/>
                        <Route path={'guess-myprize/:id'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/luckdraw/GuessMyprize').default)
                            }, 'guessMyprize')
                        }}/>
                        <Route path={'inform'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/Inform').default)
                            }, 'inform')
                        }}/>
                        <Route path={'informfill'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/InformFill').default)
                            }, 'informFill')
                        }}/>
                        <Route path={'testmsgsend'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                this.isWeixinLogin(cb,require('../containers/invitation-page/TestMsgSend').default)
                            }, 'testMsgSend')
                        }}/>
                        <Route path={'test'} getComponent={(location, cb) => {
                            require.ensure([], require => {
                                cb(null, require('../containers/invitation-page/Test').default)
                            }, 'test')
                        }}/>
                    </Route>
                </Router>
            </Router>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/index-mobile.js